import type {
  GitArtifactAPIResponsesReduxState,
  GitArtifactUIReduxState,
} from "../types";

export const gitArtifactUIInitialState: GitArtifactUIReduxState = {};

export const gitArtifactAPIResponsesInitialState: GitArtifactAPIResponsesReduxState =
  {};
